/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: Draft = 0, Published = 1, Archived = 2
 */
export enum Routemize_Constants_BookingFormStatus {
    DRAFT = 'Draft',
    PUBLISHED = 'Published',
    ARCHIVED = 'Archived',
}
